import { connect } from 'react-redux';
import SiteListsForEngineer from './siteListsForEngineer';
import { bindActionCreators } from 'redux';
import {
  getSiteListingForEngg,
  getSiteFilters,
  getLocationChange,
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
  siteListData: state.siteListingReducer.siteListData,
  siteFiltersForEngg: state.siteListingReducer.siteFiltersData,
  locationChange: state.siteListingReducer.locationChange,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteListingForEngg,
      getSiteFilters,
      getLocationChange,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteListsForEngineer);
